import { Component } from '@angular/core';
import { TableRegroupementActivite } from '../../../../data/schemas/table.schema';
import { routeAlias } from '../../../../../routesalias';
import { UiTable } from '../../../../components/ui/table/table.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-regroupementactivities',
  imports: [],
  templateUrl: './regroupementactivities.component.html',
  styleUrl: './regroupementactivities.component.css'
})
export class RegroupementactivitiesPage {
  public tableEntity = TableRegroupementActivite
  public routealias = routeAlias;
  public entities : any[] = []
}
